import { FigmaNodeReferenceData } from "./data/figma-node-reference";
import { DesignElementBase } from "./base";
import { z } from "zod";
export const FigmaNodeReferenceOrigin = z.object({
    sourceId: z.string(),
    parentName: z.string().optional(),
});
export const FigmaNodeReference = DesignElementBase.extend({
    data: FigmaNodeReferenceData,
    origin: FigmaNodeReferenceOrigin,
});
